<template>
<!--common_top_area -->
<div class="common_top_area">
    <p class="com_text fl">{{loginUser}}</p>

    <div class="dropmenu fl">
        <ul>
            <li>
                <a class="logindf_btn">main01</a>
                <ul>
                    <li>
                        <a @click="profile">{{ $t('page-header.profile') }}</a>
                    </li>
                    <li>
                        <a @click="personalAddress">{{ $t('page-header.personal-address') }}</a>
                    </li>
                    <li>
                        <a @click="logout">{{ $t('page-header.logout') }}</a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
    <p class="com_btn fl" style="width:90px; margin-right:10px;" v-if="isAdmin" @click="goAdminPage">{{ $t('page-header.admin-page') }}</p>
    <p class="com_btn fl">{{ $t('page-header.manual') }}</p>
    <!-- lang -->
    <div class="lang fl" @mouseenter="langMouseEnter" @mouseleave="langMouseLeave">
        <div class="lang_btn">
            <span :style="`background: url(/static/images/index/${selectedLang === 'kr' ? 'lang_kr.png': 'lang_en.png'}) 13px 0 no-repeat;padding-left:30px;`">한국</span>
        </div>
        <slide-up-down
            :active="active"
            :use-hidden="this.useHidden"
            :class="this.timing"
            :duration="this.duration">
            <ul class="langdrop">
                <li>
                    <a class="kor" @click="setLocale('kr')">kor</a>
                </li>
                <li>
                    <a class="eng" @click="setLocale('en')">eng</a>
                </li>
            </ul>
        </slide-up-down>
    </div>
    <!--//lang -->
</div>
<!--//common_top_area -->
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import Util from '@/util';

export default {
  name: 'app-toolbar',
  components: {
    SlideUpDown
  },
  data: () => ({
    langs: [
      {
        locale: 'kr',
        display: '한국어',
        imgSrc: '/static/images/kor.png'
      },
      {
        locale: 'en',
        display: 'English',
        imgSrc: '/static/images/eng.png'
      },
      
    ],
    selectedLang: {},
    items: [
      // {
      //   icon: 'account_circle',
      //   href: '#',
      //   title: 'Profile',
      //   click: (e) => {
      //     window.getApp.$emit('APP_GO_PROFILE');
      //   }
      // },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Logout',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
    noticeMsg: '',
    isNotice: false,
    manualDialog: false,
    interval: 5,
    webexHistory: {},
    useHidden: true,
    timing: '',
    duration: 500,
    active: false,
    loginUser: null,
    isAdmin: false
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  created () {
    if (!Util.hasSession(this, true)) return;
    if (this.$store.state.user) {
      this.loginUser = this.$store.state.user.username;
      this.isAdmin = this.$store.state.user.authorize === 'a' ? true : false;
    } else {
      this.loginUser = null;
      this.isAdmin = false;
    }
    this.selectedLang = this.$i18n.locale;// this.langs.find(lang => lang.locale === this.$i18n.locale)['locale'];
    
  },
  methods: {
    langMouseEnter () {
      this.active = true;
    },
    langMouseLeave () {
      this.active = false;
    },
    setLocale (lang) {
      this.selectedLang = lang;
      this.$i18n.locale = this.selectedLang; // this.selectedLang.locale;
      this.$store.dispatch('setLocale', this.$i18n.locale);
    },
    korVersion () {
      console.log('korVersion');
    },
    engVersion () {
      console.log('engVersion');
    },
    profile () {
      this.$router.push({ name: 'Profile' });
    },
    personalAddress () {
      this.$router.push({ name: 'PersonalAddress' });
    },
    logout () {
      console.log(`RightSite.vue logout`, `window.getApp.$emit('APP_LOGOUT');`);
      window.getApp.$emit('APP_LOGOUT');
    },
    goAdminPage () {
      this.$router.push({ name: 'Dashboard' });
    }
  }
};    
</script>

<style scoped>
.common_top_area{
    position: fixed;
    z-index: 100;
    right: 2%;
}
</style>


// WEBPACK FOOTER //
// src/components/home/RightSide.vue